import {
  ApiBlueprint,
  PageBlueprint,
  createFrontendPlugin,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/frontend-plugin-api';
import { spogApiRef } from './api/types';
import { SpogClient } from './api/SpogClient';
import { spogRouteRef } from './routes';
import { SHOW_OPENCOST_FLAG } from './featureFlags';

const spogApi = ApiBlueprint.make({
  name: 'spog',
  params: defineParams =>
    defineParams({
      api: spogApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new SpogClient({ discoveryApi, fetchApi }),
    }),
});

// noHeader because SpogPage draws its own PluginHeader with the tab strip.
const spogPage = PageBlueprint.make({
  params: {
    path: '/spog',
    routeRef: spogRouteRef,
    noHeader: true,
    loader: () => import('./components/SpogPage').then(m => <m.SpogPage />),
  },
});

export const spogPlugin = createFrontendPlugin({
  pluginId: 'spog',
  routes: { root: spogRouteRef },
  featureFlags: [{ name: SHOW_OPENCOST_FLAG }],
  extensions: [spogApi, spogPage],
});
